import { Tooltip, Typography } from '@mui/material'
import React from 'react'

export default function TruncateMiddle({ text, minLength = 20 }: { text: string, minLength?: number }) {
    if (text.length <= minLength) return <span>{text}</span>

    const start = text.slice(0, 10)
    const end = text.slice(-10)

    return (
        <Tooltip title={
            <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                {text}
            </Typography>
        } sx={{}}>
            <span>{start}...{end}</span>
        </Tooltip>
    )
}
